export const API_ROOT = 'http://services.mnc.takemedia.pt/'
export const COACH_IMG_PATH = API_ROOT + 'media/coach/'
export const COACH_SAVER_PATH = API_ROOT + 'media/screensaver/'
export const SLIDE_IMG_PATH = API_ROOT + 'media/slide/'
export const BACKGROUND_IMG_PATH = API_ROOT + 'media/background/'
export const EXTERIOR_IMG_PATH = API_ROOT + 'media/exterior/'

export const CookieDomain = (process.env.NODE_ENV === 'production')
? 'mnc.takemedia.pt'
: ''

var categories = {}
categories.enqhistorico = 2
categories.cartecnica = 3
categories.ambepoca = 4
categories.eraumavez = 5
categories.panorama = 1

export const MENUS = categories

export const CONTENT_STATES = [
  {id: 1, name: 'Rascunho'},
  {id: 2, name: 'Pendente'},
  {id: 3, name: 'Publicado'}
]

export const LANGUAGE_LIST = [
  {slug: 'pt', name: 'PT'},
  {slug: 'en', name: 'EN'},
  {slug: 'es', name: 'ES'},
  {slug: 'fr', name: 'FR'}
]

export const WHITE_COLOR = {
  hex: '#FFFFFF',
  hsl: {
    h: 0,
    s: 0,
    l: 1,
    a: 1
  },
  hsv: {
    h: 0,
    s: 0,
    v: 1,
    a: 1
  },
  rgba: {
    r: 255,
    g: 255,
    b: 255,
    a: 1
  },
  a: 1
}



// WEBPACK FOOTER //
// ./src/config.js